import { Command } from '../Command';
import { NodeUtils } from 'Editor/services/DataManager/models';
import { EditorService } from '_common/services';
import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';
import { ErrorElementNotEditable } from '../../Errors';

export class EditEquationCommand extends Command {
  // Convert the API format to the format accepted by the equation editor.
  private normalizeEquationLatex(latex: string) {
    // The API returns the accent3 symbol as \stackrel{⃛}{a} but the equation editor only accepts \dddot{a}.
    return latex.replace(/\\stackrel\{\u20DB\}\{([^{}]*)\}/g, '\\dddot{$1}');
  }

  async handleExec() {
    this.buildActionContext();

    if (!this.context.DataManager || !this.actionContext) {
      throw new Error('Context is not defined');
    }

    // check if element is editable
    if (!this.context.DataManager.nodes.isNodeEditable(this.actionContext.baseModel.id)) {
      throw new ErrorElementNotEditable();
    }

    const result = NodeUtils.closestOfTypeByPath(
      this.actionContext.baseData,
      this.actionContext.range.start.p,
      ['equation'],
    );
    const closest = result?.data;

    if (closest?.properties?.equation) {
      let tex = '';

      try {
        const { data } = await new EditorService().convertEquation(closest.properties.equation);
        if (typeof data === 'string') {
          tex = this.normalizeEquationLatex(data);
        }
      } catch {
        // Keep the original MathML in the preview when legacy LaTeX conversion fails.
      }

      ReduxInterface.openAndUpdateModal({
        modal: 'EquationsModal',
        data: {
          isEdit: true,
          equation: {
            elementId: closest.id,
            tex,
            mathml: closest?.properties?.equation,
            blockId: this.actionContext.baseModel.id,
          },
        },
      });
    }
  }
}
